function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "20241738-E84C-4D42-AD70-282533997697");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.74975,7.5 C6.55775,7.5 6.36575,7.427 6.21975,7.28 L0.21975,1.28 C-0.07325,0.988 -0.07325,0.512 0.21975,0.22 C0.51275,-0.073 0.98675,-0.073 1.27975,0.22 L6.74975,5.689 L12.21975,0.22 C12.51275,-0.073 12.98675,-0.073 13.27975,0.22 C13.57275,0.512 13.57275,0.988 13.27975,1.28 L7.27975,7.28 C7.13375,7.427 6.94075,7.5 6.74975,7.5",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "btn/arrow-close-icon/arrow-down"
}, /*#__PURE__*/React.createElement("g", {
  id: "Colors/main/Green",
  transform: "translate(8.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#4CA2FF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Colors/main/Green-Colors/Black/Natural",
  mask: "url(#mask-2)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8.000000, -11.000000)",
  id: "Colors/Black/Natural"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 30,
  height: 30
}))))));

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.f1dbc8c0.svg";
export { ForwardRef as ReactComponent };